var ResizeObserverBoxOptions = /*#__PURE__*/function (ResizeObserverBoxOptions) {
  ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
  ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
  ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
  return ResizeObserverBoxOptions;
}(ResizeObserverBoxOptions || {});
export { ResizeObserverBoxOptions };